import { HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Sort } from '@angular/material/sort'
import { BaseService } from '@mybitzer/core/base.service'
import { Customer, CustomerSearchRequest, CustomerSearchResultEntry } from '@mybitzer/core/customer/customer.api'
import { UserLanguageApi } from '@mybitzer/core/language/language.api'
import { Page, PatchRequest } from '@mybitzer/core/shared/shared.api'
import { CustomerInfo } from '@mybitzer/shared/customer/customer.api'
import { map, Observable, Subscription } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class CustomerService extends BaseService implements UserLanguageApi {
  constructor() {
    super('customer')
    this.retryCount = 1
  }

  searchCustomer(request: CustomerSearchRequest, page: number, size: number, sort: Sort | undefined): Observable<Page<CustomerInfo>> {
    let params = new HttpParams().set('page', page).set('size', size)
    if (sort && sort.active && sort.direction !== '') {
      params = params.append('sort', `${sort.active},${sort.direction}`)
    }
    return this.post('search', request, params)
  }

  getById(id: string): Observable<CustomerInfo> {
    return this.get(id)
  }

  setName(id: number, value: string): Observable<Customer> {
    return this.patch(id + '/name', new PatchRequest(value))
  }

  getByEmail(email: string): Observable<Customer> {
    return this.get('mail?email=' + email)
  }

  findByEmail(email: string[]): Observable<Customer[]> {
    return this.get('find/by/email?email=' + email)
  }

  remove(id: number): Observable<Customer> {
    return this.delete(id + '')
  }

  setSubscriptionTypes(customerId: number, types: string[]): Observable<Subscription> {
    return this.put(customerId + '/subscription', new PatchRequest(types))
  }

  getSelf(): Observable<Customer> {
    return this.get('self')
  }

  getUserLang(): Observable<string> {
    return this.getSelf().pipe(map((customer) => customer?.language ?? ''))
  }

  setUserLang(lang: string): Observable<Customer> {
    return this.patch('self/language', new PatchRequest(lang))
  }

  autocomplete(fullTextSearch: string, page: number, size: number): Observable<Page<CustomerSearchResultEntry>> {
    const params = new HttpParams().set('page', page).set('size', size).set('fullTextSearch', fullTextSearch)
    return this.get('autocomplete', params)
  }
}
